<template>
<div class="ti">
  <div>
    <!-- <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="ERP.isPermission(6002001)">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select> -->

    <el-select size="mini" v-model="value1" filterable placeholder="请选择类型" class="kuan">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options6"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>


    <el-input size="mini" class="search" placeholder="请输入搜索账号" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <!-- <th class="text-left">组织ID</th> -->
            <th class="text-left">操作人</th>
            <th class="text-left">操作类型</th>
            <th class="text-left">操作内容</th>
            <th class="text-left">操作时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <!-- <td >{{item.company_id}}</td> -->
            <td >{{item.name}}</td>
            <td >{{item.caozuo}}</td>
            <td >{{item.caozuoxiangqin}}</td>
            <td > {{item.date}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
</div>

</template>

<script>
export default {
  name: 'OperationLog',
  data () {
    return {
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      dades: {
        id:'',
        name:'',
        identification_card:'',
        phone: '',
        company_id: '',
        pindex_id:'',
        gender:'',
      },
       options: [
        {
          value: '',
          label: ''
        },],
        options6: [
        {
          id: '项目',
          name: '项目',
        },
        {
          id: '订单',
          name: '订单',
        },
        {
          id: '会员',
          name: '会员',
        },
        {
          id: '操作',
          name: '操作',
        },
        {
          id: '架构',
          name: '架构',
        },
        {
          id: '小程序',
          name: '小程序',
        },
        {
          id: '轮播图',
          name: '轮播图',
        },
        {
          id: '设置',
          name: '设置',
        },
        ],
        opdade:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.$myhttp.get('admin/log?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/log?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      this.$myhttp.get('admin/log?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Operation/log.vue